
import { Component, Prop, Vue } from 'vue-property-decorator';
import StripePaymentMethodService from '@/Services/Subscription/StripePaymentMethodService';
import StripeCheckoutService from '@/Services/Subscription/StripeCheckoutService';
import Icon from '@/components/Icons/Icon.vue';
import { ValidationProvider } from 'vee-validate';
@Component({
  components: {
    Icon,
    ValidationProvider,
  },
})
export default class EmailAndNotes extends Vue {
  @Prop({ type: StripePaymentMethodService })
  paymentMethodService!: StripePaymentMethodService;
  @Prop({ type: StripeCheckoutService })
  checkoutService!: StripeCheckoutService;
  showNotes = false;
  /**
   * Hides the note input and clears it
   */
  removeNotes(): void {
    this.showNotes = false;
    if (this.checkoutService.customer.invoice_settings.custom_fields) {
      this.checkoutService.customer.invoice_settings.custom_fields[0].value = '';
    }
  }
}
